// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"a_-z"};